import { Component } from '@angular/core';

@Component({
  selector: 'wz-page-title',
  templateUrl: './tunnelsante-page-title.component.html',
  styleUrls: ['./tunnelsante-page-title.component.scss'],
  standalone: false,
})
export class TunnelSantePageTitleComponent {}
